import { BiDownload, BiShare } from "react-icons/bi";
import { RxLoop } from "react-icons/rx";
import ShareModal from "./ShareModal";
import { useState } from "react";

const FinishedQuiz = ({ score, questionsCount, handleReset, type }) => {
  const [openModal, setOpenModal] = useState(false);
  const totalScore = questionsCount * 10;
  return (
    <div
      className="pt-4 d-flex flex-column "
      style={{
        height: "100%",
        width: "100%",
        justifyContent: "center",
      }}
    >
      <div className="">
        <h3
          style={{
            height: "10vh",
          }}
        >
          Quiz Completed!
        </h3>

        <h4>
          {score}/{totalScore}.
        </h4>
        <h6>
          {" "}
          {score > 0
            ? "You performed quite well sir."
            : "Well tried sir. You can do it next time"}
        </h6>
        <p className="mt-3"> Keep practicing !</p>
        <div className="d-flex flex-column gap-2 align-items-center ">
          <button
            style={{ border: "none" }}
            onClick={handleReset}
            className="bg-info rounded-3 w-md-25 w-50 p-3  text-white  "
          >
            <RxLoop /> Play Again
          </button>
          <button
            style={{ border: "none" }}
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=com.ayata.medipuzzle&hl=en&gl=US"
              )
            }
            className="bg-danger w-50 rounded-3 p-3 gap-2 d-flex justify-content-center align-items-center  text-white  "
          >
            <BiDownload />
            Install App
          </button>
          <button
            style={{ border: "none" }}
            onClick={() => setOpenModal(true)}
            className="bg-warning w-50 rounded-3 p-3 gap-2 d-flex justify-content-center align-items-center  text-white  "
          >
            <BiShare />
            Share
          </button>
        </div>
      </div>
      <ShareModal
        setModalOpen={setOpenModal}
        type={type}
        openModal={openModal}
        score={score}
      />
    </div>
  );
};
export default FinishedQuiz;
